/* Kameleon theme JS — no dependencies */
(function () {
  'use strict';
  var K = window.kameleon || { routes: {}, strings: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function money(minor) {
    var fmt = K.moneyFormat || '{{amount}}';
    var probe = String(K.moneyProbe || '0.01');
    var m = probe.match(/[.,](\d+)$/);
    var decimals = m ? m[1].length : 2;
    var v = minor / Math.pow(10, decimals);
    var s;
    if (/amount_no_decimals/.test(fmt)) { s = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    else if (/amount_with_comma_separator/.test(fmt)) { s = v.toFixed(decimals).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))(?=[^,]*,)/g, '.'); }
    else if (/amount_with_space_separator/.test(fmt) || /amount_with_period_and_space_separator/.test(fmt)) { s = v.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))(?=[^.]*\.)/g, ' '); }
    else { s = v.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))(?=[^.]*\.)/g, ','); }
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }

  /* ---------- Edit storage ---------- */
  var EDIT_KEY = 'kameleon_edit';
  var SKIP_KEY = 'kameleon_journey_skipped';
  var Edit = {
    get: function () {
      try {
        var raw = localStorage.getItem(EDIT_KEY);
        if (!raw) return null;
        var e = JSON.parse(raw);
        if (e.expires && Date.now() > e.expires) { localStorage.removeItem(EDIT_KEY); return null; }
        return e;
      } catch (err) { return null; }
    },
    set: function (edit, days) {
      try {
        edit.expires = Date.now() + (days || 90) * 86400000;
        localStorage.setItem(EDIT_KEY, JSON.stringify(edit));
        localStorage.removeItem(SKIP_KEY);
      } catch (err) {}
    },
    clear: function () { try { localStorage.removeItem(EDIT_KEY); localStorage.removeItem(SKIP_KEY); } catch (err) {} },
    skipped: function () { try { return localStorage.getItem(SKIP_KEY) === '1'; } catch (err) { return true; } },
    skip: function () { try { localStorage.setItem(SKIP_KEY, '1'); } catch (err) {} }
  };

  function productData(key) {
    var el = $('[data-product-json="' + key + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (err) { return null; }
  }

  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

  /* ---------- Overlays ---------- */
  function openOverlay(el) { if (!el) return; el.hidden = false; document.body.classList.add('overlay-open'); var f = el.querySelector('button, a, input'); if (f) f.focus(); }
  function closeOverlay(el) { if (!el) return; el.hidden = true; document.body.classList.remove('overlay-open'); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-open]'); if (t) { openOverlay($('[data-mobile-menu]')); return; }
    t = e.target.closest('[data-menu-close]'); if (t) { closeOverlay($('[data-mobile-menu]')); return; }
    t = e.target.closest('[data-size-guide-open]'); if (t) { e.preventDefault(); openOverlay($('#SizeGuide')); return; }
    t = e.target.closest('[data-drawer-close]'); if (t) { closeOverlay(t.closest('[data-drawer]')); return; }
    t = e.target.closest('[data-account-prompt-open]'); if (t) { e.preventDefault(); AccountPrompt.open(); return; }
    t = e.target.closest('[data-account-prompt-close]'); if (t) { closeOverlay($('[data-account-prompt]')); return; }
    t = e.target.closest('[data-cart-notification-close]'); if (t) { $('#CartNotification').hidden = true; return; }
    t = e.target.closest('[data-recover-open]'); if (t) { e.preventDefault(); $('#LoginForm').hidden = true; $('[data-recover]').hidden = false; return; }
    t = e.target.closest('[data-recover-close]'); if (t) { $('#LoginForm').hidden = false; $('[data-recover]').hidden = true; return; }
    t = e.target.closest('[data-address-toggle]'); if (t) { var box = document.getElementById(t.getAttribute('data-address-toggle')); if (box) box.hidden = !box.hidden; return; }
    t = e.target.closest('[data-address-delete]'); if (t) {
      if (window.confirm(t.getAttribute('data-confirm') || 'Delete?')) {
        var f = document.createElement('form'); f.method = 'post'; f.action = t.getAttribute('data-address-delete');
        f.innerHTML = '<input type="hidden" name="_method" value="delete">'; document.body.appendChild(f); f.submit();
      }
      return;
    }
    t = e.target.closest('[data-journey-restart]'); if (t) { e.preventDefault(); Edit.clear(); if (Journey.root) { Journey.show(1); } else { window.location.href = (K.routes.root || '/') + '#edit'; } return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $$('[data-drawer]:not([hidden]), [data-account-prompt]:not([hidden]), [data-mobile-menu]:not([hidden])').forEach(closeOverlay); }
  });
  if (location.hash === '#recover' && $('[data-recover]')) { $('#LoginForm').hidden = true; $('[data-recover]').hidden = false; }

  /* ---------- Journey ---------- */
  var Journey = {
    root: $('[data-journey]'),
    step: 0,
    piece: 'crew',
    colours: {},
    init: function () {
      if (!this.root) return;
      var self = this;
      var edit = Edit.get();
      var inEditor = window.Shopify && window.Shopify.designMode;
      if (location.hash === '#edit') { Edit.clear(); this.show(1); }
      else if (!edit && !Edit.skipped() && !inEditor) this.show(0);

      this.root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-journey-skip]'); if (t) { Edit.skip(); self.hide(); return; }
        t = e.target.closest('[data-journey-next]'); if (t) { self.show(self.step + 1); return; }
        t = e.target.closest('[data-journey-piece]'); if (t) { self.selectPiece(t.getAttribute('data-journey-piece')); return; }
        t = e.target.closest('[data-journey-colour]'); if (t) { self.toggleColour(t); return; }
        t = e.target.closest('[data-journey-finish]'); if (t) { self.finish(); return; }
      });
      this.selectPiece('crew');
    },
    show: function (n) {
      this.step = n; this.root.hidden = false; document.body.classList.add('journey-open');
      $$('[data-journey-step]', this.root).forEach(function (s) { s.hidden = s.getAttribute('data-journey-step') !== String(n); });
      this.root.scrollTop = 0;
      var h = $('[data-journey-step="' + n + '"] .journey__title', this.root); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
    },
    hide: function () { this.root.hidden = true; document.body.classList.remove('journey-open'); },
    selectPiece: function (key) {
      this.piece = key;
      $$('[data-journey-piece]', this.root).forEach(function (b) { var on = b.getAttribute('data-journey-piece') === key; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      $$('[data-journey-colours]', this.root).forEach(function (g) { g.hidden = g.getAttribute('data-journey-colours') !== key; });
    },
    toggleColour: function (btn) {
      var group = btn.closest('[data-journey-colours]');
      var on = !btn.classList.contains('is-selected');
      var selected = $$('.colour-card.is-selected', group).length;
      if (!on && selected <= 1) return; /* keep at least one */
      btn.classList.toggle('is-selected', on); btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    },
    finish: function () {
      var group = $('[data-journey-colours="' + this.piece + '"]', this.root);
      var colours = $$('.colour-card.is-selected', group).map(function (b) { return b.getAttribute('data-journey-colour'); });
      var data = productData(this.piece) || {};
      Edit.set({ piece: this.piece, handle: data.handle, title: data.title, colours: colours, at: Date.now() }, parseInt(this.root.getAttribute('data-days'), 10) || 90);
      this.hide();
      YourEdit.render();
      window.scrollTo({ top: 0 });
    }
  };

  /* ---------- Your edit ---------- */
  var YourEdit = {
    root: $('[data-your-edit]'),
    render: function () {
      var edit = Edit.get();
      var root = this.root;
      if (!root) return;
      if (!edit) { root.hidden = true; document.body.classList.remove('has-edit'); return; }
      var data = productData(edit.piece);
      var other = productData(edit.piece === 'crew' ? 'polo' : 'crew');
      if (!data) { root.hidden = true; return; }
      document.body.classList.add('has-edit');
      root.hidden = false;
      $('[data-edit-piece-name]', root).textContent = data.title;
      var chips = $('[data-edit-chips]', root); chips.innerHTML = '';
      (data.colours || []).forEach(function (c) {
        if (edit.colours.indexOf(c.key) === -1) return;
        var s = document.createElement('span'); var i = document.createElement('i'); i.style.background = c.hex; s.appendChild(i); s.appendChild(document.createTextNode(cap(c.name))); chips.appendChild(s);
      });
      $$('[data-edit-hero]', root).forEach(function (h) { h.hidden = h.getAttribute('data-edit-hero') !== edit.piece; });
      $$('[data-edit-list]', root).forEach(function (l) { l.hidden = l.getAttribute('data-edit-list') !== edit.piece; });
      $$('[data-edit-also]', root).forEach(function (a) { a.hidden = a.getAttribute('data-edit-also') === edit.piece; });
      $$('[data-edit-colour]', root).forEach(function (el) { el.classList.toggle('is-hidden', edit.colours.indexOf(el.getAttribute('data-edit-colour')) === -1); });
      if (!other) $$('[data-edit-also]', root).forEach(function (a) { a.hidden = true; });
    }
  };

  /* ---------- Account prompt / summaries ---------- */
  var AccountPrompt = {
    fill: function (scope) {
      var edit = Edit.get(); if (!edit) return false;
      var data = productData(edit.piece); if (!data) return false;
      var thumbs = $('[data-prompt-thumbs]', scope); var summary = $('[data-prompt-summary]', scope);
      if (thumbs) { thumbs.innerHTML = ''; data.colours.forEach(function (c) { if (edit.colours.indexOf(c.key) === -1 || !c.image) return; var img = document.createElement('img'); img.src = c.image; img.alt = c.name; img.width = 40; img.height = 50; thumbs.appendChild(img); }); }
      if (summary) summary.textContent = data.title + ' · ' + edit.colours.length + ' colour' + (edit.colours.length === 1 ? '' : 's');
      return true;
    },
    open: function () {
      var m = $('[data-account-prompt]'); if (!m) { window.location.href = K.routes.register || '/account/register'; return; }
      this.fill(m); openOverlay(m);
    }
  };
  /* register + account pages: show the edit and pass it as a note */
  (function () {
    var reg = $('[data-register-edit]'); if (reg && AccountPrompt.fill(reg)) { reg.hidden = false; var note = $('[data-register-edit-note]'); var e = Edit.get(); if (note && e) note.value = e.piece + ':' + e.colours.join(','); }
    var acc = $('[data-account-edit]'); if (acc && AccountPrompt.fill(acc)) acc.hidden = false;
  })();

  /* ---------- Colour edit chips (static home) ---------- */
  $$('[data-colour-edit]').forEach(function (sec) {
    sec.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-colour-toggle]'); if (!chip) return;
      var on = !chip.classList.contains('is-on');
      if (!on && $$('[data-colour-toggle].is-on', sec).length <= 1) return;
      chip.classList.toggle('is-on', on); chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      var key = chip.getAttribute('data-colour-toggle');
      $$('[data-colour-item="' + key + '"]', sec).forEach(function (el) { el.classList.toggle('is-hidden', !on); });
    });
  });

  /* ---------- Collection filters ---------- */
  $$('[data-collection]').forEach(function (sec) {
    var type = '';
    var colours = null;
    function apply() {
      $$('[data-collection-grid] > [data-type]', sec).forEach(function (el) {
        var okType = !type || el.getAttribute('data-type') === type;
        var c = el.getAttribute('data-colour');
        var okColour = !colours || !c || colours.indexOf(c) !== -1;
        el.classList.toggle('is-hidden', !(okType && okColour));
      });
    }
    sec.addEventListener('click', function (e) {
      var t = e.target.closest('[data-type-filter]');
      if (t) { type = t.getAttribute('data-type-filter'); $$('[data-type-filter]', sec).forEach(function (b) { var on = b === t; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); apply(); return; }
      var d = e.target.closest('[data-colour-filter]');
      if (d) {
        var all = $$('[data-colour-filter]', sec);
        if (colours === null) colours = all.map(function (b) { return b.getAttribute('data-colour-filter'); });
        var key = d.getAttribute('data-colour-filter'); var on = !d.classList.contains('is-on');
        if (!on && colours.length <= 1) return;
        d.classList.toggle('is-on', on); d.setAttribute('aria-pressed', on ? 'true' : 'false');
        colours = on ? colours.concat([key]) : colours.filter(function (k) { return k !== key; });
        apply();
      }
    });
    var sort = $('[data-sort]', sec);
    if (sort) sort.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); window.location.href = u.toString(); });
  });

  /* ---------- Cart helpers ---------- */
  function updateCounts(cart) { $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; }); }
  function notify(item) {
    var n = $('#CartNotification'); if (!n) return;
    $('[data-cart-notification-title]', n).textContent = item.product_title;
    $('[data-cart-notification-variant]', n).textContent = item.variant_title ? item.variant_title.replace(/ \/ /g, ' · ') : '';
    var m = $('[data-cart-notification-image]', n); m.innerHTML = '';
    if (item.image) { var img = document.createElement('img'); img.src = item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2'); img.alt = ''; m.appendChild(img); }
    n.hidden = false; clearTimeout(notify.t); notify.t = setTimeout(function () { n.hidden = true; }, 6000);
  }
  function addToCart(id, qty) {
    return fetch(((K.routes.cartAdd || '/cart/add').replace(/\.js$/, '')) + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Error'); }); return r.json(); })
      .then(function (res) { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { updateCounts(cart); notify(res.items ? res.items[0] : res); return cart; }); });
  }

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(function (sec) {
    var dataEl = $('[data-product-data]', sec); if (!dataEl) return;
    var product; try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var colourIndex = parseInt(sec.getAttribute('data-colour-index'), 10);
    var sizeIndex = parseInt(sec.getAttribute('data-size-index'), 10);
    var form = $('[data-product-form]', sec);
    var idInput = $('[data-variant-id]', sec);
    var addBtn = $('[data-add-to-bag]', sec);
    var addLabel = $('[data-add-label]', sec);
    var priceEl = $('[data-price]', sec);
    var colourLabel = $('[data-colour-label]', sec);
    var soldNote = $('[data-sold-note]', sec);
    var gallery = $('[data-gallery]', sec);

    function selected() {
      var opts = [];
      var c = $('[data-option-colour]:checked', sec); var s = $('[data-option-size]:checked', sec);
      product.options.forEach(function (name, i) { opts[i] = null; });
      if (c) opts[colourIndex] = c.value;
      if (s) opts[sizeIndex] = s.value;
      $$('[data-option-other]', sec).forEach(function (sel) { opts[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value; });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; }); })[0] || null;
    }
    function refreshSizes(colour) {
      var sold = [];
      $$('[data-option-size]', sec).forEach(function (input) {
        var v = product.variants.filter(function (v) { return v.options[colourIndex] === colour && v.options[sizeIndex] === input.value; })[0];
        var label = input.nextElementSibling;
        var available = !!(v && v.available);
        label.classList.toggle('size--sold', !available);
        if (!available) sold.push(input.value);
      });
      if (soldNote) soldNote.textContent = sold.length ? sold.join(', ') + ' in ' + cap(colour) + (sold.length > 1 ? ' are' : ' is') + ' sold out.' : '';
    }
    function update() {
      var opts = selected();
      var v = findVariant(opts);
      if (colourLabel && opts[colourIndex]) colourLabel.textContent = cap(opts[colourIndex]);
      if (opts[colourIndex]) refreshSizes(opts[colourIndex]);
      if (!v) { addBtn.disabled = true; addLabel.textContent = K.strings.unavailable || 'Unavailable'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = '<span class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '"><span class="price__current">' + money(v.price) + '</span>' + (v.compare_at_price > v.price ? '<s class="price__compare">' + money(v.compare_at_price) + '</s>' : '') + '</span>';
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? (K.strings.addToBag || 'Add to bag') + ' · ' + money(v.price) : (K.strings.soldOut || 'Sold out');
      var targetMedia = v.featured_media && v.featured_media.id;
      if (v.featured_image && v.featured_image.src && product.media) {
        var fsrc = v.featured_image.src.split('?')[0].split('/').pop();
        var mm = product.media.filter(function (m) { return m.preview_image && m.preview_image.src && m.preview_image.src.split('?')[0].split('/').pop() === fsrc; })[0];
        if (mm) targetMedia = mm.id;
      }
      if (gallery) {
        var colourKey = (opts[colourIndex] || '').toLowerCase();
        /* show only this colour's photos; untagged media (e.g. video) always show */
        $$('[data-media-colour]', gallery).forEach(function (el) {
          var mc = el.getAttribute('data-media-colour');
          el.hidden = !!(mc && colourKey && mc !== colourKey);
        });
        var oldLead = $('.product__media--lead', gallery); if (oldLead) oldLead.classList.remove('product__media--lead');
        var m = targetMedia ? $('[data-media-id="' + targetMedia + '"]', gallery) : null;
        if (!m) m = $$('[data-media-id]', gallery).filter(function (el) { return !el.hidden; })[0];
        if (m) { m.classList.add('product__media--lead'); if (m !== gallery.firstElementChild) gallery.insertBefore(m, gallery.firstElementChild); }
        gallery.scrollTo({ left: 0 }); galleryDots();
      }
      var buyMeta = $('[data-buy-bar-meta]'); if (buyMeta) buyMeta.innerHTML = '<span>' + (v.title || '').replace(/ \/ /g, ' · ') + '</span><strong>' + money(v.price) + '</strong>';
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (err) {}
      /* let add-ons (Smart Fit) know which variant is selected — no personal data */
      sec.dispatchEvent(new CustomEvent('kameleon:variant-change', { detail: { id: v.id, size: opts[sizeIndex], colour: opts[colourIndex], available: v.available } }));
    }
    /* mobile gallery: swipe with dots + counter (desktop keeps the grid) */
    var dots = $('[data-gallery-dots]', sec), countEl = $('[data-gallery-count]', sec);
    function galleryDots() {
      if (!gallery || !dots) return;
      var slides = $$('[data-media-id]', gallery).filter(function (el) { return !el.hidden; });
      var w = gallery.clientWidth || 1; var i = Math.min(slides.length - 1, Math.max(0, Math.round(gallery.scrollLeft / w)));
      dots.innerHTML = slides.map(function (_, k) { return '<span' + (k === i ? ' class="is-on"' : '') + '></span>'; }).join('');
      if (countEl) countEl.textContent = slides.length ? (i + 1) + ' / ' + slides.length : '';
      var prev = $('[data-gallery-prev]', sec), nxt = $('[data-gallery-next]', sec);
      if (prev) prev.disabled = i <= 0; if (nxt) nxt.disabled = i >= slides.length - 1;
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gallery-prev], [data-gallery-next]'); if (!b || !gallery) return;
      gallery.scrollBy({ left: (b.hasAttribute('data-gallery-next') ? 1 : -1) * gallery.clientWidth, behavior: 'smooth' });
    });
    if (gallery) { var galleryT; gallery.addEventListener('scroll', function () { clearTimeout(galleryT); galleryT = setTimeout(galleryDots, 60); }, { passive: true }); window.addEventListener('resize', galleryDots); galleryDots(); }
    sec.addEventListener('change', function (e) { if (e.target.matches('[data-option-colour], [data-option-size], [data-option-other]')) update(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.disabled = true;
      addToCart(parseInt(idInput.value, 10), 1).then(function () { addBtn.disabled = false; sec.dispatchEvent(new CustomEvent('kameleon:add-to-cart', { detail: { id: parseInt(idInput.value, 10), size: selected()[sizeIndex] } })); }).catch(function (err) { addBtn.disabled = false; window.alert(err.message); });
    });

    /* size chart: move the table out of the description */
    var desc = $('[data-product-description]', sec); var chartBox = $('[data-size-chart]', sec);
    if (desc && chartBox) { var table = desc.querySelector('table'); if (table) { chartBox.appendChild(table); $('[data-size-chart-accordion]', sec).hidden = false; var fb = $('[data-size-guide-fallback]'); if (fb) fb.appendChild(table.cloneNode(true)); } }

    /* mobile sticky buy bar */
    var bar = document.createElement('div'); bar.className = 'buy-bar';
    bar.innerHTML = '<div class="buy-bar__meta" data-buy-bar-meta></div><button type="button" class="btn">' + (K.strings.addToBag || 'Add to bag') + '</button>';
    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click', function () { if (addBtn.disabled) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (entries) { bar.classList.toggle('is-visible', !entries[0].isIntersecting); }, { threshold: 0 }).observe(addBtn); }
    update();
  });

  /* ---------- Cart page ---------- */
  $$('[data-cart-page]').forEach(function (sec) {
    function change(line, qty) {
      return fetch(((K.routes.cartChange || '/cart/change').replace(/\.js$/, '')) + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function () { window.location.replace(window.location.pathname); }).catch(function () { window.location.replace(window.location.pathname); });
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-change]');
      if (b) { var input = $('[data-qty-input]', b.parentNode); var q = Math.max(0, parseInt(input.value, 10) + parseInt(b.getAttribute('data-qty-change'), 10)); input.value = q; change(parseInt(input.getAttribute('data-line'), 10), q); return; }
      var r = e.target.closest('[data-line-remove]');
      if (r) { e.preventDefault(); change(parseInt(r.getAttribute('data-line'), 10), 0); return; }
      var d = e.target.closest('[data-discount-apply]');
      if (d) { var code = ($('[data-discount-input]', sec).value || '').trim(); if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(K.routes.cart || '/cart'); }
    });
    sec.addEventListener('change', function (e) { var i = e.target.closest('[data-qty-input]'); if (i) change(parseInt(i.getAttribute('data-line'), 10), Math.max(0, parseInt(i.value, 10) || 0)); });
  });

  /* ---------- Addresses ---------- */
  if (window.Shopify && window.Shopify.CountryProvinceSelector) {
    $$('[data-address-country]').forEach(function (sel) {
      var prov = sel.getAttribute('data-province-target');
      new window.Shopify.CountryProvinceSelector(sel.id || (sel.id = 'C' + Math.random().toString(36).slice(2)), prov, { hideElement: 'ProvinceWrap-' + prov.replace('Province-', '') });
    });
  }

  /* ---------- Boot ---------- */
  Journey.init();
  YourEdit.render();
  document.addEventListener('shopify:section:load', function () { YourEdit.render(); });
  /* theme editor: show the journey while its section is selected */
  document.addEventListener('shopify:section:select', function (e) { if (Journey.root && e.target.contains(Journey.root)) Journey.show(0); });
  document.addEventListener('shopify:section:deselect', function (e) { if (Journey.root && e.target.contains(Journey.root)) Journey.hide(); });
})();
